import SummaryLoaderItem from './summary-loader-item';

export default class SummaryLoader {
  _source;
  _summaryLoaders;
  constructor(source) {
    this._source = source;
    this._summaryLoaders = {};

    for (const columnSetting of source.query.columnSettings.columns) {
      this._summaryLoaders[columnSetting.column.id] = new SummaryLoaderItem(source, columnSetting);
    }
  }

  loader(column) {
    return this._summaryLoaders[column.id];
  }

  invalidate() {
    for (const key of Object.keys(this._summaryLoaders)) {
      const item = this._summaryLoaders[key];

      item.reset();
    }
  }
}
